export default __webpack_public_path__ + "3beb02ff8734db647a430b2c2ba39a3d.png";